<div class="field-wrapper" fxLayout="row" fxFlex="100%">
  <div fxFlex>
    <button
      aria-label="Upload file"
      class="primary"
      mat-stroked-button
      (click)="inputFile.click()"
      [disabled]="disabled"
      type="button"
    >
      <mat-icon *ngIf="icon && !loading">{{ icon }}</mat-icon>
      <mat-spinner *ngIf="loading" diameter="25"></mat-spinner>
      {{ text }}
    </button>
    <input
      type="file"
      #inputFile
      hidden
      [accept]="accept"
      (change)="fileSelected($event)"
      aria-label="File URL"
    />
  </div>
</div>
